import { render, staticRenderFns } from "./BuyNow.vue?vue&type=template&id=06e14087&scoped=true"
import script from "./BuyNow.vue?vue&type=script&lang=js"
export * from "./BuyNow.vue?vue&type=script&lang=js"
import style0 from "./BuyNow.vue?vue&type=style&index=0&id=06e14087&prod&lang=scss"
import style2 from "./BuyNow.vue?vue&type=style&index=2&id=06e14087&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e14087",
  null
  
)

export default component.exports